import { useQuery } from '@tanstack/react-query';

import {
  partnersCampaignsApi,
  partnersCampaignsApiKeys,
  type PartnerCampaignsListParams,
} from '@/api/routes/partners/partners.campaigns.api';

/** The campaigns the Bodyprint built on the partner's offers (drafts never show). */
export const usePartnersReadCampaigns = (params: PartnerCampaignsListParams) => {
  return useQuery({
    queryKey: partnersCampaignsApiKeys.list(params),
    queryFn: () => partnersCampaignsApi.list(params).then((res) => res.data),
  });
};
